<template>
  <div id="shortcuts">
    <v-item-group mandatory>
      <v-row class="shortcuts" justify="center">
        <v-col
            v-for="(item, i) in items"
            :key="i"
            :cols="cols"
            :sm="smCols"
            :md="mdCols"
        >
          <v-item v-slot="{ active, toggle }">
            <v-btn color="primary" class="d-flex align-center" height="50" :to="item.path" @click="toggle">
              {{ $t(item.text) }}
            </v-btn>
          </v-item>
        </v-col>
      </v-row>
    </v-item-group>
  </div>
</template>

<script>
import {config} from '~/plugins/config'

export default {
  name: "Shortcuts",
  computed: {
    items() {
      return config('settings.content.shortcut.shortcuts.direct');
    },
    color() {
      return config('settings.theme.colors.anchor');
    },
    smCols() {
      return config('settings.content.shortcut.sm_cols');
    },
    mdCols() {
      return config('settings.content.shortcut.md_cols');
    },
    cols() {
      return config('settings.content.shortcut.cols');
    },
  }
}
</script>

<style lang="scss" scoped>
.shortcuts::v-deep .v-btn {
  white-space: normal;
}
.shortcuts::v-deep .v-btn .v-btn__content{
  flex: 1 1 auto;
  text-align: center;
}


</style>